import type { ProviderSpectators } from "../types";

export const useLivekitSpectators = (): ProviderSpectators => ({
  peers: [],
  loadPeers: () => Promise.resolve(),
  loadMorePeers: () => Promise.resolve(),
  hasNext: () => false,
  total: 1,
});
